import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TextareaAutosize,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DaumPostcode from 'react-daum-postcode';
import Calendar from 'react-calendar';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';

import 'react-calendar/dist/Calendar.css';
import './react-calendar.css';
import MainTitle from '../components/Text/MainTitle';
import axiosInstance, {
  checkDeadline,
  emailValidation,
  EVENT_CODE,
  EVENT_ID,
  F_EMAIL,
  focusElementRef,
  getEventId,
  krMobileValidation,
  readFile,
  SPONSORSUBMIT_TEMPLATE,
  WEB_API,
  // addComma,
} from '../constatns';
import swal from '@sweetalert/with-react';
import queryString from 'query-string';
import cloneDeep from 'lodash/cloneDeep';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadToS3 from '../common/UploadToS3';
import UploadToVimeo from '../common/UploadToVimeo';
import axios from 'axios';

import CircularProgress from '@material-ui/core/CircularProgress';

const moment = require('moment');

const StyledTableCell = withStyles((theme) => ({
  head: {},
  body: {
    fontSize: 15,
    // borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    // '&:nth-last-child(1)': {
    //   borderRight: 'none',
    // },
  },
}))(TableCell);

const styles = (theme) => ({
  root: {
    '& th': {
      width: '240px !important',
    },
  },
  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '1.3em',
  },
  title2: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  OutlinedInput: {
    width: '100%',
    padding: '5px 7px',
    '& .MuiOutlinedInput-input': {
      padding: '4px 10px',
    },
  },
  borderNone: {
    width: '100%',
    padding: '5px 7px',
    '& .MuiOutlinedInput-input': {
      padding: '4px 10px',
    },
    '& *': {
      border: 'none',
    },
  },
  radioGroup: {
    '& *': {
      fontSize: 14,
    },
  },
  btn: {
    padding: '5px 7px',
  },
  addCountSelect: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  popupDiv: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1111,
  },
  popupPaper: {
    display: 'block',
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '600px',
    padding: '7px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    zIndex: 2222,
  },
});

const GRADE = {
  typeA: 'A Type (A zone 택1) - 8,800,000원',
  typeB: 'B Type (B zone 택1) - 6,600,000원',
  onlineBooth: '온라인 부스(학술대회 홈페이지에 부스 기능을 다양한 형태로 구현하여 기업 및 제품홍보) – 4,400,000원',
  onlineAd: '온라인 광고(온라인 강의 송출 화면 광고(break time)) – 4,400,000원',
};

const ISADD = {
  // PB1: '프로그램 북 표1 – (2,200,000원)',
  PB2: '프로그램 북 표2 – (1,650,000원)',
  PB3: '프로그램 북 표3 – (1,100,000원)',
  PB4: '프로그램 북 표4 – (2,200,000원)',
  // PB5: '프로그램북 내지 – (770,000원)',
  // eBOOK: '초록집 내지– (770,000원)',
  N: '프로그램 북 표지 미신청',
};

class ExhibiApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      nameEn: '',
      licenseNum: '',
      ceo: '',
      manager: '',
      mDept: '',
      mRank: '',
      mTel: '',
      mobile: '',
      mFax: '',
      mEmail: '',

      grade: 'N',
      isAdd: '',
      boothNo: '',
      // addCount: 0,
      abstractCount: 0,
      addPgmBookCount: 0,
      item1: '',
      item2: '',
      item3: '',
      totalPrice: 0,
      recipient: '',
      taxEmail: '',
      taxDate: '',
      postalCode: '',
      address: '',
      adrDetail: '',
      chkLicenseNum: false,
      applicationType: '',
      itemType: '',
      etc: '',
      doc1: '',
      doc2: '',
      doc3: '',
      logo: '',
      businessLicense: '',
      openCalendarDeposit: false,
      isAgree: false,
      isCheckInnerBook: 0, // 프로그램북 내지 신청
      isCheckInnerAbstract: 0, // 초록집 내지 신청
      checkPB2: '',
      checkPB3: '',
      checkPB4: '',
    };

    this.refTaxEmail = React.createRef();
    this.refMEmail = React.createRef();
    this.refMDept = React.createRef();
    this.refMobile = React.createRef();
    this.refName = React.createRef();
    this.refNameEn = React.createRef();
    this.refLicenseNum = React.createRef();
    this.refChkLicenseNum = React.createRef();
    this.refCeo = React.createRef();
    this.refPostalCode = React.createRef();
    this.refAddress = React.createRef();
    this.refAdrDetail = React.createRef();
    this.refManager = React.createRef();
    this.refMRank = React.createRef();
    this.refMTel = React.createRef();
    this.refMFax = React.createRef();
    this.refBoothNo = React.createRef();
    this.refItem1 = React.createRef();
    this.refRecipient = React.createRef();
    this.refTaxDate = React.createRef();
    this.refDepositDate = React.createRef();
    this.refApllicationType = React.createRef();
    this.refItemType = React.createRef();
    this.refBusinessLicense = React.createRef();
    this.refAgree = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
    this.onChangeCal = this.onChangeCal.bind(this);
    this.changeToModifyMode = this.changeToModifyMode.bind(this);
  }

  componentDidMount() {
    // console.log(checkDeadline('sponsorDeadline'));
    if (sessionStorage.getItem('EVENT')) {
      // if (!this.props.isAdmin && !checkDeadline('sponsorDeadline')) {
      //   swal('The application period has ended.');
      //   this.props.history.push('/main');
      // }
    } else {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
            if (!checkDeadline('sponsorDeadline')) {
              swal('The application period has ended.');
              this.props.history.push('/main');
            }
          }
        });
    }

    const mode = queryString.parse(this.props.location.search)['mode'];
    this.setState({ mode: mode });

    if (this.props.isPop) {
      this.setState(this.props.infoData);
      this.setState({ mode: this.props.mode, boothId: this.props.boothId });
    } else {
      this.getInfoData();
    }

    this.getIsPgmBookAvailable();
    this.getIsBoothAvailable();
  }

  getInfoData() {
    const boothId = this.state.boothId || queryString.parse(this.props.location.search)['boothId'];
    if (boothId) {
      axiosInstance.get(`${WEB_API}/sponsor/info?eventId=${EVENT_ID}&boothId=${boothId}`).then((result) => {
        if (result.data.Item) {
          console.log(result.data.Item);
          delete result.data.Item.mode;
          this.setState(result.data.Item);
          this.setState({ boothId: boothId });
        }
      });
    }
  }

  getIsPgmBookAvailable = () => {
    let pgmBookAvailable = [
      'PB2',
      'PB3',
      'PB4',
      // { title: 'PB1', value: 2200000 },
      // { title: 'PB2', value: 1650000 },
      // { title: 'PB3', value: 1100000 },
      // { title: 'PB4', value: 2200000 },
    ];

    axiosInstance.get(`${WEB_API}/sponsor/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      // console.log(response.data, 'res');
      if (response.data && response.data.length > 0) {
        const _data = response.data;
        //eslint-disable-next-line
        _data.map((d) => {
          //eslint-disable-next-line
          pgmBookAvailable.map((p, idx) => {
            if (p === d.isAdd) {
              pgmBookAvailable.splice(idx, 1);
            }
          });
          this.setState({ pgmBookAvailable });

          if (pgmBookAvailable.indexOf('PB2') !== -1) {
            this.setState({ checkPB2: false });
          } else {
            this.setState({ checkPB2: true });
          }
          if (pgmBookAvailable.indexOf('PB3') !== -1) {
            this.setState({ checkPB3: false });
          } else {
            this.setState({ checkPB3: true });
          }
          if (pgmBookAvailable.indexOf('PB4') !== -1) {
            this.setState({ checkPB4: false });
          } else {
            this.setState({ checkPB4: true });
          }
        });
        // }
        // if (d.isAdd !== 'N' && d.isAdd !== 'eBOOK' && d.isAdd !== 'PB5') {
        //   pgmBookAvailable.map((p, idx) => {
        //     if (p.title === d.isAdd) {
        //       pgmBookAvailable.splice(idx, 1);
        //     }
        //   });
        // this.setState({ pgmBookAvailable });
      } else {
        this.setState({ checkPB2: false, checkPB3: false, checkPB4: false });
      }
    });
  };

  getIsBoothAvailable = () => {
    let typeA = []; //A1~A14
    let typeB = []; //B1~B19

    axios.get(`https://p8qthqkie0.execute-api.ap-northeast-2.amazonaws.com/latest/booth/checkBooth?evt=evt120`).then((resp) => {
      if (resp.data) {
        for (let i = 0; i <= resp.data.length; i++) {
          if (resp.data[i] && resp.data[i].indexOf('A') !== -1) {
            typeA.push(resp.data[i]);
          } else {
            typeB.push(resp.data[i]);
          }
          this.setState({ typeA, typeB });
        }
      }
    });
  };

  handleChange(type, e) {
    if (type == 'applicationType' && e.target.value === 'Advertise') {
      this.setState({
        [type]: e.target.value,
        grade: 'N',
        isAdd: 'N',
        totalPrice: 0,
        abstractCount: 0,
        addPgmBookCount: 0,
        isCheckInnerBook: 0,
        isCheckInnerAbstract: 0,
      });
    } else {
      this.setState({ [type]: e.target.value });
    }
    this.setState({ [type]: e.target.value });
  }

  searchLicenseNum() {
    const _license = this.state.licenseNum.replace(/\-/gi, '');
    if (_license < 1) {
      swal('사업자등록번호를 입력해주세요.');
      return;
    }
    if (/[^0-9]/g.test(_license)) {
      swal('숫자 또는 - 만 입력가능합니다.');
      return;
    }

    axiosInstance.get(`${WEB_API}/sponsor/checkNum?eventId=${EVENT_ID}&licenseNum=${_license}`).then((res) => {
      if (res.data.exists) {
        // swal('이미 가입하셨습니다.');
        swal('이미 등록된 사업자등록번호입니다.');
        this.setState({ chkLicenseNum: false });
      } else {
        swal('가입할 수 있는 사업자 번호입니다.');
        this.setState({ chkLicenseNum: true });
      }
    });
  }

  calcTotalPrice(type, e) {
    const priceByGrade = {
      typeA: 8800000,
      typeB: 6600000,
      // onlineBooth: 4400000,
      // onlineAd: 4400000,
      N: 0,
    };
    const priceByAd = {
      PB2: 1650000,
      PB3: 1100000,
      PB4: 2200000,
      N: 0,
      '': 0,
      // PB1: 2200000,
      // PB5: 770000,
      // eBOOK: 770000,
    };

    if (type === 'innerBook') {
      this.setState({
        isCheckInnerBook: e.target.checked ? 770000 : 0,
      });
    }
    if (type === 'innerAbstract') {
      this.setState({
        isCheckInnerAbstract: e.target.checked ? 770000 : 0,
      });
    }
    if (type === 'abstractCount') {
      this.setState({ abstractCount: e.target.value });
    }
    if (type === 'addPgmBookCount') {
      this.setState({ addPgmBookCount: e.target.value });
    }
    // 미신청일 때 금액 및 체크항목 리셋
    if (type === 'isAdd') {
      if (e.target.value === 'N') {
        this.setState({ isCheckInnerBook: 0, addPgmBookCount: 0 });
      } else {
      }
    }

    this.setState({ [type]: e.target.value }, () => {
      if (this.state.isAdd === 'PB2') {
        this.setState({ addName: '프로그램 북 표2' });
      }
      if (this.state.isAdd === 'PB3') {
        this.setState({ addName: '프로그램 북 표3' });
      }
      if (this.state.isAdd === 'PB4') {
        this.setState({ addName: '프로그램 북 표4' });
      }
      if (
        this.state.isAdd === 'N' ||
        (this.state.isAdd === '' && (this.state.isCheckInnerAbstract !== 0 || this.state.isCheckInnerBook !== 0))
      ) {
        this.setState({ addName: '프로그램 북 표지 미신청' });
      }

      this.setState({
        totalPrice:
          priceByGrade[this.state.grade] +
          priceByAd[this.state.isAdd] +
          this.state.isCheckInnerAbstract * this.state.abstractCount +
          this.state.isCheckInnerBook * this.state.addPgmBookCount,
      });
    });

    // if (type === 'none') {
    //   if (type === 'innerAbstract') {
    //     this.setState({
    //       isCheckInnerAbstract: e.target.checked ? 770000 : 0,
    //     });
    //   }
    //   // if (this.state.isAdd === 'eBOOK') {
    //   //   this.setState({ addCount: 1 });
    //   // }

    //   // if (this.state.isCheckInnerAbstract !== 0) {
    //   //   this.setState({ addCount: 1 });
    //   // }

    //   // if (this.state.isCheckInnerBook !== 0) {
    //   //   this.setState({ addPgmBookCount: 1 });
    //   // }
    //   this.setState({ grade: 'N' }, () => {
    //     this.setState({
    //       totalPrice:
    //         // priceByGrade[this.state.grade] + priceByAd[this.state.isAdd]
    //         priceByGrade[this.state.grade] + priceByAd[this.state.isAdd],

    //       // this.state.isCheckInnerAbstract * this.state.addCount +
    //       // abstractTotal +
    //       // this.state.isCheckInnerBook * this.state.addPgmBookCount,
    //     });
    //   });
    // } else {
    //   if (type === 'innerBook') {
    //     this.setState({
    //       isCheckInnerBook: e.target.checked ? 770000 : 0,
    //     });
    //   }
    //   if (type === 'innerAbstract') {
    //     this.setState({
    //       isCheckInnerAbstract: e.target.checked ? 770000 : 0,
    //     });
    //   }
    //   this.setState({ [type]: e.target.value }, () => {
    //     if (this.state.isCheckInnerAbstract !== 0 && this.state.addCount == 0) {
    //       this.setState({ addCount: 1 });
    //     }
    //     this.setState({
    //       totalPrice:
    //         // priceByGrade[this.state.grade] + priceByAd[this.state.isAdd]
    //         priceByGrade[this.state.grade] + priceByAd[this.state.isAdd] + this.state.isCheckInnerAbstract,
    //       // + this.state.isCheckInnerBook,
    //     });
    //   });
    // }
  }

  onChangeCal(date, key) {
    this.setState({ [key]: date, openCalendar: false, openCalendarDeposit: false });
  }

  onChangeFile = async (event, file) => {
    const targetFile = event.target.files[0];

    await readFile(targetFile, -1)
      .then((f) => {
        this.setState({
          // [`${file}_prev`]: f.target.result,
          // [`${file}_name`]: targetFile.name,
          [`${file}`]: targetFile,
        });
      })
      .catch((err) => {
        swal(err);
      });
  };

  fileDelete = (e, file) => {
    e.preventDefault();
    let swalText = '파일을 삭제하시겠습니까?';
    swal({
      text: swalText,
      buttons: {
        cancle: {
          text: '취소',
          value: false,
        },
        confirm: {
          text: '확인',
          value: true,
        },
      },
      closeOnClickOutside: false,
    }).then((isAgree) => {
      if (isAgree) {
        if (file !== 'doc3') {
          axiosInstance
            .post(`${WEB_API}/sponsor/img`, {
              evt: EVENT_ID,
              boothId: this.state.boothId,
              delKey: file,
              delPath: this.state[file].path,
            })
            .then((res) => {
              this.setState({ [file]: null });
            })
            .catch((err) => {
              console.error(err);
            });
        } else if (file === 'doc3') {
          // this.removeVimeoFile(file);
        }
      } else {
        return false;
      }
    });
  };

  handleSignUp() {
    // if (this.state.isAdd === 'PB2') {
    //   this.setState({ addName: '프로그램 북 표2' });
    // }
    // if (this.state.isAdd === 'PB3') {
    //   this.setState({ addName: '프로그램 북 표3' });
    // }
    // if (this.state.isAdd === 'PB4') {
    //   this.setState({ addName: '프로그램 북 표4' });
    // }
    // if (this.state.isAdd === '') {
    //   this.setState({ addName: '프로그램 북 표지 미신청' });
    // }

    const mobileNo = this.state.mobile.replace(/[\s*+#._-]/gi, '');
    if (!this.state.name) {
      focusElementRef('회사명(국문)을 입력해주세요.', this.refName);
      return false;
    } else if (!/([가-힣]{2,})/gi.test(this.state.name)) {
      focusElementRef('회사명(국문)을 다시 한번 확인해주세요.', this.refName);
      return false;
    } else if (!this.state.nameEn) {
      focusElementRef('회사명(영문)을 입력해주세요.', this.refNameEn);
      return false;
    } else if (!/([a-z'-\s]{1,})/gi.test(this.state.nameEn)) {
      focusElementRef('회사명(영문)을 다시 한번 확인해주세요.', this.refNameEn);
      return false;
    } else if (!this.state.licenseNum) {
      focusElementRef('사업자등록번호를 입력해주세요.', this.refLicenseNum);
      return false;
    } else if (this.state.mode !== 'modify' && !this.state.chkLicenseNum) {
      focusElementRef('사업자등록번호 확인을 해주세요.', this.refChkLicenseNum);
      return false;
    } else if (!this.state.ceo) {
      focusElementRef('대표자명을 입력해주세요.', this.refCeo);
      return false;
    } else if (!this.state.businessLicense) {
      focusElementRef('사업자등록증을 첨부해주세요.', this.refBusinessLicense);
      return false;
    } else if (!this.state.manager) {
      focusElementRef('담당자명을 입력해주세요.', this.refManager);
      return false;
    } else if (!this.state.mDept) {
      focusElementRef('담당자부서를 입력해주세요.', this.refMDept);
      return false;
    } else if (!this.state.mRank) {
      focusElementRef('담당자직급을 입력해주세요.', this.refMRank);
      return false;
    } else if (!this.state.mTel) {
      focusElementRef('담당자 전화번호를 입력해주세요.', this.refMTel);
      return false;
    } else if (!this.state.mobile) {
      // focusElementRef('담당자 휴대폰번호 입력해주세요.', this.refMobile);
      focusElementRef('휴대폰번호를 입력해주세요.', this.refMobile);
      return false;
    } else if (!krMobileValidation(mobileNo)) {
      focusElementRef('휴대폰 번호가 올바르지 않습니다.', this.refMobile);
      return false;
    } else if (!this.state.mEmail) {
      focusElementRef('담당자 이메일 주소를 입력해주세요.', this.refMEmail);
      return false;
    } else if (!emailValidation(this.state.mEmail)) {
      focusElementRef('이메일 형식이 올바르지 않습니다.', this.refMEmail);
      return false;
    } else if (!this.state.postalCode) {
      focusElementRef('우편번호를 입력해주세요.', this.refPostalCode);
      return false;
    } else if (!this.state.address) {
      focusElementRef('담당자 주소를 입력해주세요.', this.refAddress);
      return false;
    } else if (!this.state.adrDetail) {
      focusElementRef('담당자 상세주소를 입력해주세요.', this.refAdrDetail);
      return false;
    } else if (!this.state.applicationType) {
      focusElementRef('구분을 입력해주세요.', this.refApllicationType);
      return false;
    } else if (this.state.applicationType !== 'Advertise' && this.state.grade === 'N') {
      swal('신청내용을 선택해주세요.');
      return false;
    } else if (this.state.applicationType === 'Offline' && !this.state.boothNo) {
      focusElementRef('부스번호를 선택해주세요.', this.refBoothNo);
      return false;
    } else if (!this.state.itemType) {
      focusElementRef('홍보 품목 종류를 입력해주세요.', this.refItemType);
      return false;
    } else if (!this.state.item1) {
      focusElementRef('홍보 품목을 입력해주세요.', this.refItem1);
      return false;
    } else if (!this.state.depositDate) {
      focusElementRef('입금 예정일을 입력해주세요.', this.refDepositDate);
      return false;
    } else if (!this.state.recipient) {
      focusElementRef('수령인을 입력해주세요.', this.refRecipient);
      return false;
    } else if (!this.state.taxEmail) {
      focusElementRef('발행 요청 이메일을 입력해주세요.', this.refTaxEmail);
      return false;
    } else if (!emailValidation(this.state.taxEmail)) {
      focusElementRef('발행 이메일 형식이 올바르지 않습니다.', this.refTaxEmail);
      return false;
    } else if (!this.state.taxDate) {
      focusElementRef('발행 요청일을 입력해주세요.', this.refTaxDate);
      return false;
    } else if (!this.state.isAgree) {
      focusElementRef('환불규정에 동의해주세요.', this.refAgree);
      return false;
    }
    // else if (this.state.isAdd === '') {
    //   focusElementRef('프로그램 북 신청사항을 선택해주세요.');
    //   return false;
    // }

    const param = cloneDeep(this.state);
    param['licenseNum'] = this.state.licenseNum.replace(/\-/gi, '');
    param['mobile'] = this.state.mobile.replace(/\-/gi, '');
    param['mTel'] = this.state.mTel.replace(/\-/gi, '');
    param['evt'] = EVENT_ID;
    param['eventCode'] = EVENT_CODE.replace('#', '');

    if (this.props.isAdmin) {
      param['memo'] = this.state.memo;
    }

    let url = `${WEB_API}/sponsor/`;
    if (this.state.mode === 'modify') url = `${WEB_API}/sponsor/mod`;

    let arrExcept = [
      'popUpOpen',
      'chkLicenseNum',
      'openCalendar',
      'openCalendarDeposit',
      'mode',
      'logo',
      'doc1',
      'doc2',
      'banner',
      // 'ad',
      // 'ad02',
      // 'ad03',
      // 'addCount',
      // 'programBookTable',
      // 'programBookTable02',
      // 'programBookTable03',
      // 'abstractCount',
      // 'addPgmbookCount',
      // 'businessLicense',
      'pgmBookAvailable',
      'typeA',
      'typeB',
      'checkPB2',
      'checkPB3',
      'checkPB4',
    ];
    for (let i = 0; i < arrExcept.length; i++) {
      delete param[`${arrExcept[i]}`];
    }

    // if (param['isAdd'] === 'N') delete param['addCount'];
    console.log(param, 'param');
    axiosInstance
      .post(`${url}`, param)
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data.boothId, 'boothId');
          this.fileUpload(res.data.boothId);
          // swal('success');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fileUpload = async (boothId) => {
    const fileFormData = new FormData();
    fileFormData.append('evt', EVENT_ID);
    fileFormData.append('boothId', boothId);

    let idx = 0;
    let maxFile = 0;
    for (const [key, value] of Object.entries(this.state)) {
      if (
        key === 'logo' ||
        key === 'banner' ||
        key === 'doc1' ||
        key === 'doc2' ||
        key === 'ad' ||
        key === 'ad02' ||
        key === 'ad03' ||
        key === 'programBookTable' ||
        key === 'programBookTable02' ||
        key === 'programBookTable03' ||
        key === 'businessLicense'
      ) {
        if (value instanceof File) {
          maxFile++;
        }
      }
    }

    // console.log(idx, maxFile);

    new Promise(async (resolve, reject) => {
      if (maxFile === 0) resolve();
      for (const [key, value] of Object.entries(this.state)) {
        if (value) {
          if (
            key === 'logo' ||
            key === 'banner' ||
            key === 'doc1' ||
            key === 'doc2' ||
            key === 'ad' ||
            key === 'ad02' ||
            key === 'ad03' ||
            key === 'programBookTable' ||
            key === 'programBookTable02' ||
            key === 'programBookTable03' ||
            key === 'businessLicense'
          ) {
            if (value instanceof File) {
              await UploadToS3(value, 'PRS2021/booth', boothId, key).then((upload) => {
                fileFormData.append(key + '_DUP', JSON.stringify(upload));
                idx++;
                if (idx === maxFile) {
                  resolve();
                }
              });
            }
          } else if (key === 'doc3') {
            if (value instanceof File) {
              await UploadToVimeo(value, 'PRS2021/booth', boothId, key).then((upload) => {
                fileFormData.append(key + '_DUP', JSON.stringify(upload));
              });
            }
          }
        }
      }
    }).then(() => {
      axiosInstance
        .post(`${WEB_API}/sponsor/mod`, fileFormData, {
          'Content-Type': 'multipart/form-data',
        })
        .then((result) => {
          console.log(result, 'result');

          // axiosInstance
          //   .post(
          //     `${WEB_API}/sponsor/sponsorSubmitEmail?evt=${EVENT_ID}&sponsorId=${boothId}&templateName=${SPONSORSUBMIT_TEMPLATE}&from=${F_EMAIL}`,
          //   )
          //   .then((res) => {
          //     console.log(res, 'mail_res');
          //   });
          let swalText = '등록되었습니다.';
          if (this.state.mode === 'modify') {
            swalText = '수정되었습니다.';
          } else {
            axiosInstance
              .post(
                `${WEB_API}/sponsor/sponsorSubmitEmail?evt=${EVENT_ID}&sponsorId=${boothId}&templateName=${SPONSORSUBMIT_TEMPLATE}&from=${F_EMAIL}`,
              )
              .then((res) => {
                console.log(res, 'mail_res');
              });
          }
          swal(swalText, {
            icon: 'success',
          }).then(() => {
            if (this.props.isPop) {
              this.props.handleClose();
            } else {
              if (this.state.mode === 'modify') {
                this.setState({ mode: 'read', boothId: boothId });
                this.getInfoData();
              } else {
                this.props.history.push('/sponsor/signin?moveTo=application');
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ isSubmitting: false, del_logo: false, del_doc1: false, del_doc2: false });
        });
    });
  };

  changeToModifyMode = () => {
    this.setState({ mode: 'modify' });
  };

  setPopupOpen() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'hidden';
    this.setState({ popUpOpen: true });
  }

  setPopupClose() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'auto';
    this.setState({ popUpOpen: false });
  }

  render() {
    const { classes } = this.props;
    const { mode } = this.state;
    const readOnly = Boolean(mode === 'read');
    const handleComplete = (data) => {
      let fullAddress = data.address;
      let extraAddress = '';

      if (data.addressType === 'R') {
        if (data.bname !== '') {
          extraAddress += data.bname;
        }
        if (data.buildingName !== '') {
          extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
        }
        fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
      }
      this.setState({ address: fullAddress, postalCode: data.zonecode }, () => {
        this.setPopupClose();
      });
    };

    // console.log(this.state.typeA, 'A');
    // console.log(this.state.checkPB2, 'pb2');
    // console.log(this.state.checkPB3, 'pb3');
    // console.log(this.state.mode, 'mode');
    return (
      <div>
        <CssBaseline />
        {!this.props.isPop && <Topbar MIdx={5} SIdx={1} />}
        <Container>
          <Grid container justifyContent={'center'} style={this.props.isPop ? { padding: 20 } : { padding: 0 }} className={classes.root}>
            <Grid item xs={this.props.isPop ? 12 : 8}>
              {!this.props.isPop && <MainTitle>Online Exhibition Application</MainTitle>}
              <h3 className={classes.title2}>업체정보{/* {this.state.mode} */}</h3>
              <Table>
                <TableBody>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>회사명
                    </StyledTableCell>
                    <StyledTableCell align="center" width="80%">
                      <Grid container alignItems="stretch" direction={'column'} spacing={2} justifyContent="space-between">
                        <Grid item>
                          <OutlinedInput
                            className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                            startAdornment={<InputAdornment position="start">국문 : </InputAdornment>}
                            onChange={(e) => {
                              this.handleChange('name', e);
                            }}
                            value={this.state.name || ''}
                            readOnly={readOnly}
                            inputRef={this.refName}
                          />
                        </Grid>
                        <Grid item>
                          <OutlinedInput
                            className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                            startAdornment={<InputAdornment position="start">영문 : </InputAdornment>}
                            onChange={(e) => {
                              this.handleChange('nameEn', e);
                            }}
                            value={this.state.nameEn}
                            readOnly={readOnly}
                            inputRef={this.refNameEn}
                          />
                        </Grid>
                      </Grid>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>사업자등록번호
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      <Grid container>
                        <OutlinedInput
                          required
                          className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                          style={{ width: '30%', marginRight: '10px', paddingLeft: 0 }}
                          onChange={(e) => {
                            this.handleChange('licenseNum', e);
                            this.setState({ chkLicenseNum: false });
                          }}
                          value={this.state.licenseNum}
                          readOnly={readOnly}
                          inputRef={this.refLicenseNum}
                        />
                        {mode !== 'read' && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                color="primary"
                                checked={this.state.chkLicenseNum}
                                onChange={(e) => {
                                  this.searchLicenseNum(e);
                                }}
                                inputRef={this.refChkLicenseNum}
                              />
                            }
                            label={<span style={{ color: '#aaa', fontSize: '0.9em' }}>사업자등록번호 확인</span>}
                          />
                        )}
                      </Grid>
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>대표자
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('ceo', e);
                        }}
                        value={this.state.ceo}
                        readOnly={readOnly}
                        inputRef={this.refCeo}
                        style={{ paddingLeft: 0 }}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>사업자등록증
                    </StyledTableCell>
                    <StyledTableCell>
                      <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                        <Grid item xs={6}>
                          <input
                            style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                            type="file"
                            id={'comp-picker'}
                            accept="application/pdf, image/*"
                            ref={this.refBusinessLicense}
                            onChange={(e) => this.onChangeFile(e, 'businessLicense')}
                          />
                          {this.state.businessLicense && this.state.businessLicense.path && (
                            <span style={{ lineHeight: '30px' }}>
                              &nbsp;&nbsp;&nbsp;
                              <a href={this.state.businessLicense.path} target={'_blank'}>
                                {this.state.businessLicense.name}
                              </a>
                              {this.state.mode === 'modify' && (
                                <IconButton
                                  aria-label="delete"
                                  className={classes.margin}
                                  onClick={(e) => this.fileDelete(e, 'businessLicense')}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              )}
                            </span>
                          )}
                        </Grid>
                        {this.state.mode !== 'read' && (
                          <Grid item xs={6}>
                            * PDF, JPG, GIF, PNG
                          </Grid>
                        )}
                      </Grid>
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <h3 className={classes.title2}>담당자 정보</h3>
              <Table>
                <TableBody>
                  <TableRow>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>이름
                    </StyledTableCell>
                    <StyledTableCell width={'35%'}>
                      <OutlinedInput
                        required
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('manager', e);
                        }}
                        value={this.state.manager}
                        readOnly={readOnly}
                        inputRef={this.refManager}
                      />
                    </StyledTableCell>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>부서
                    </StyledTableCell>
                    <StyledTableCell width={'35%'}>
                      <OutlinedInput
                        required
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mDept', e);
                        }}
                        value={this.state.mDept}
                        readOnly={readOnly}
                        inputRef={this.refMDept}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>직급
                    </StyledTableCell>

                    <StyledTableCell align="center" width={'35%'}>
                      <OutlinedInput
                        required
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mRank', e);
                        }}
                        value={this.state.mRank}
                        readOnly={readOnly}
                        inputRef={this.refMRank}
                      />
                    </StyledTableCell>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>전화
                    </StyledTableCell>
                    <StyledTableCell width={'35%'}>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mTel', e);
                        }}
                        type="tel"
                        value={this.state.mTel}
                        readOnly={readOnly}
                        inputRef={this.refMTel}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>휴대폰
                    </StyledTableCell>

                    <StyledTableCell width={'35%'}>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mobile', e);
                        }}
                        value={this.state.mobile}
                        readOnly={readOnly}
                        type="tel"
                        inputRef={this.refMobile}
                      />
                    </StyledTableCell>
                    <StyledTableCell component="th" width={'15%'}>
                      팩스
                    </StyledTableCell>
                    <StyledTableCell width={'35%'}>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mFax', e);
                        }}
                        value={this.state.mFax}
                        readOnly={readOnly}
                        inputRef={this.refMFax}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th" width={'15%'}>
                      <span>*&nbsp;</span>이메일
                    </StyledTableCell>
                    <StyledTableCell colSpan={3} width={'85%'}>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        onChange={(e) => {
                          this.handleChange('mEmail', e);
                        }}
                        value={this.state.mEmail}
                        readOnly={readOnly}
                        inputRef={this.refMEmail}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>주소
                    </StyledTableCell>
                    <StyledTableCell colSpan={3}>
                      <Grid container alignItems="center">
                        <OutlinedInput
                          className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                          style={{ width: '30%', marginRight: '10px' }}
                          onChange={(e) => {
                            this.handleChange('postalCode', e);
                          }}
                          value={this.state.postalCode || ''}
                          readOnly={readOnly}
                          inputRef={this.refPostalCode}
                          startAdornment={<InputAdornment position="start">우편번호</InputAdornment>}
                        />
                        {mode !== 'read' && (
                          <Button
                            variant="contained"
                            color="primary"
                            disableElevation
                            className={classes.btn}
                            style={{ width: '10%', height: '37px', fontSize: '1em' }}
                            onClick={() => this.setPopupOpen()}
                          >
                            우편번호
                          </Button>
                        )}
                      </Grid>

                      <Grid container justifyContent="space-between" style={{ marginTop: 10 }}>
                        <OutlinedInput
                          className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                          // style={{ width: '49%' }}
                          style={{ width: '49%' }}
                          value={this.state.address || ''}
                          onChange={(e) => {
                            this.handleChange('address', e);
                          }}
                          inputRef={this.refAddress}
                          startAdornment={<InputAdornment position="start">주소</InputAdornment>}
                        />
                        <OutlinedInput
                          className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                          style={{ width: '49%' }}
                          // style={{ width: 'fit-content' }}
                          onChange={(e) => {
                            this.handleChange('adrDetail', e);
                          }}
                          value={this.state.adrDetail || ''}
                          readOnly={readOnly}
                          // placeholder={mode !== 'read' ? '상세주소' : ''}
                          inputRef={this.refAdrDetail}
                          startAdornment={<InputAdornment position="start">상세주소</InputAdornment>}
                        />
                      </Grid>
                      <div style={{ paddingTop: '10px', fontSize: '15px', fontWeight: 'bold' }}>
                        &nbsp;&nbsp;* 추후 학술대회 광고 증빙 인쇄물 등 발송 예정
                      </div>
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <h3 className={classes.title2}>후원 및 세금계산서 발행 정보</h3>
              <Table>
                <TableBody>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>구분
                    </StyledTableCell>
                    <StyledTableCell>
                      {mode === 'read' ? (
                        this.state.applicationType === 'Offline' ? (
                          // '오프라인'
                          '부스'
                        ) : (
                          /* 2022 CUSTOM 온라인 신청 삭제 */
                          // this.state.applicationType === 'Online' ? (
                          //   '온라인'
                          // ) :
                          '프로그램 북 & 초록집 광고'
                        )
                      ) : (
                        <FormControl component="fieldset" disabled={!this.props.isAdmin && this.state.mode === 'modify'}>
                          <RadioGroup
                            aria-label="applicationType"
                            name="applicationType"
                            onChange={(e) => {
                              this.handleChange('applicationType', e);
                              // this.calcTotalPrice('none', e);
                            }}
                            className={classes.radioGroup}
                            value={this.state.applicationType}
                          >
                            <FormControlLabel
                              value="Offline"
                              control={<Radio />}
                              label={
                                <div>
                                  오프라인
                                  {/* 오프라인 (마감) */}
                                </div>
                              }
                            />
                            {/* 2022 CUSTOM 온라인 신청 삭제 */}
                            {/* <FormControlLabel
                              value="Online"
                              inputRef={this.refApllicationType}
                              control={<Radio />}
                              label={<div>온라인</div>}
                            /> */}
                            <FormControlLabel value="Advertise" control={<Radio />} label={<div>프로그램 북 & 초록집 광고</div>} />
                          </RadioGroup>
                        </FormControl>
                      )}
                    </StyledTableCell>
                  </TableRow>

                  {/* 테이블 및 의자 신청 */}
                  {this.state.applicationType === 'Offline' && (
                    <TableRow>
                      <StyledTableCell component="th">테이블 및 의자 신청</StyledTableCell>
                      <StyledTableCell>
                        <Grid container alignItems="center" item xs={12}>
                          {mode !== 'read' && (
                            <Checkbox
                              disabled={mode === 'read'}
                              color="secondary"
                              size="small"
                              style={{ marginLeft: '-10px' }}
                              inputProps={{ 'aria-label': 'checkbox' }}
                              value={this.state.table || false}
                              onChange={(e) => {
                                this.setState({ table: e.target.checked });
                              }}
                            />
                          )}

                          {this.state.table ? (
                            <Typography style={{ fontSize: 15 }}>신청</Typography>
                          ) : (
                            <Typography style={{ fontSize: 15 }}>미신청</Typography>
                          )}
                        </Grid>
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {/* 오프라인 부스 선택 */}
                  {this.state.applicationType !== 'Advertise' && (
                    <TableRow>
                      <StyledTableCell component="th">
                        <span>*&nbsp;</span>신청내용
                      </StyledTableCell>
                      <StyledTableCell>
                        {mode === 'read' ? (
                          this.state.grade === 'N' ? (
                            '미신청'
                          ) : (
                            GRADE[this.state.grade]
                          )
                        ) : (
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="grade"
                              name="grade"
                              onChange={(e) => this.calcTotalPrice('grade', e)}
                              className={classes.radioGroup}
                              value={this.state.grade}
                            >
                              {this.state.applicationType === 'Online' ? (
                                <>
                                  <FormControlLabel
                                    value="onlineBooth"
                                    control={<Radio />}
                                    label={
                                      <div>
                                        온라인 부스(학술대회 홈페이지에 부스 기능을 다양한 형태로 구현하여 기업 및 제품홍보) – 4,400,000원
                                      </div>
                                    }
                                  />
                                  <FormControlLabel
                                    value="onlineAd"
                                    control={<Radio />}
                                    label={<div>온라인광고(온라인 강의 송출 화면 광고(break time)) – 4,400,000원</div>}
                                  />
                                </>
                              ) : (
                                this.state.applicationType === 'Offline' && (
                                  <>
                                    <FormControlLabel
                                      value="typeA"
                                      control={<Radio disabled />}
                                      // label={<div>A Type (A zone 택1) - 8,800,000원</div>}
                                      label={<div style={{ color: 'grey' }}>A Type은 모두 선정 완료 되어 마감되었습니다.</div>}
                                    />
                                    <FormControlLabel
                                      // disabled
                                      value="typeB"
                                      control={<Radio disabled />}
                                      label={<div style={{ color: 'grey' }}>B Type은 모두 선정 완료 되어 마감되었습니다.</div>}
                                      // label={
                                      //   <div>
                                      //     B Type (B zone 택1) - 6,600,000원
                                      //     {/* <b style={{ color: '#f00' }}>
                                      //     </b> */}
                                      //   </div>
                                      // }
                                    />
                                  </>
                                )
                              )}
                            </RadioGroup>
                          </FormControl>
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {this.state.applicationType === 'Offline' && this.state.grade !== 'N' && (
                    <TableRow>
                      <StyledTableCell component="th">
                        <span>*&nbsp;</span>부스번호
                      </StyledTableCell>
                      <StyledTableCell>
                        {mode === 'read' || mode === 'modify' ? (
                          this.state.boothNo
                        ) : (
                          <FormControl size="small">
                            <Select
                              variant="outlined"
                              value={this.state.boothNo}
                              ref={this.refBoothNo}
                              onChange={(e) => {
                                this.setState({ boothNo: e.target.value });
                              }}
                              classes={{
                                select: classes.addCountSelect,
                              }}
                            >
                              {this.state.grade === 'typeA'
                                ? this.state.typeA.map((no, idx) => (
                                    <MenuItem value={no} key={idx}>
                                      {no}
                                    </MenuItem>
                                  ))
                                : this.state.typeB.map((no, idx) => (
                                    <MenuItem value={no} key={idx}>
                                      {no}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                        )}
                      </StyledTableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>프로그램 북(Printed Book)
                      <br />
                      &nbsp;&nbsp;&amp;초록집(E-Book) 광고
                    </StyledTableCell>

                    <StyledTableCell>
                      {mode === 'read' ? (
                        <>
                          {ISADD[this.state.isAdd]}
                          {this.state.isCheckInnerBook !== 0 && (
                            <Grid container item xs={12}>
                              프로그램 내지 광고
                              {this.state.addPgmBookCount && this.state.addPgmBookCount !== 0 && (
                                <div>
                                  &nbsp;&nbsp;[광고 신청 수: <b>{this.state.addPgmBookCount}</b>개]
                                </div>
                              )}
                            </Grid>
                          )}
                          {this.state.isCheckInnerAbstract !== 0 ? (
                            <div>
                              {this.state.abstractCount && this.state.abstractCount !== 0 && (
                                <Grid container item xs={12}>
                                  초록집 광고 신청
                                  {this.state.abstractCount && this.state.abstractCount !== 0 && (
                                    <div>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[광고 신청 수: <b>{this.state.abstractCount}</b>개]
                                    </div>
                                  )}
                                </Grid>
                              )}
                            </div>
                          ) : (
                            '초록집 광고 미 신청'
                          )}
                        </>
                      ) : !this.props.isAdmin && this.state.mode === 'modify' ? (
                        '금액관련 항목 수정은  학회 사무국 담당자 (02-3472-4253) 으로 연락 주십시오.'
                      ) : (
                        <div style={{ flexDirection: 'row' }}>
                          {/* style={this.state.isAdd === 'Y' ? { display: 'flex', flexDirection: 'row' } : {}}> */}
                          <FormControl component="fieldset">
                            {this.state.checkPB2 === '' || this.state.checkPB3 === '' || this.state.checkPB4 === '' ? (
                              // 가능 프로그램북 정보 가져올때 까지 마감 항목 표시-> Progress bar 추가
                              <div style={{ zIndex: 9999 }}>
                                <CircularProgress size={40} thickness={3} style={{ opacity: 0.7 }} />
                              </div>
                            ) : (
                              <RadioGroup
                                aria-label="isAdd"
                                name="isAdd"
                                onChange={(e) => this.calcTotalPrice('isAdd', e)}
                                className={classes.radioGroup}
                                value={this.state.isAdd}
                              >
                                <FormControlLabel value="N" control={<Radio />} label={<div>프로그램 북 표지 미신청</div>} />
                                <FormControlLabel
                                  value="PB2"
                                  control={<Radio />}
                                  label={
                                    this.state.checkPB2 ? (
                                      <div>
                                        <del>프로그램 북 표2 – (1,650,000원)</del>
                                        <b style={{ color: 'red' }}>&nbsp;마감</b>
                                      </div>
                                    ) : (
                                      <div>프로그램 북 표2 – (1,650,000원)</div>
                                    )
                                  }
                                  disabled={this.state.checkPB2 === true}
                                />
                                <FormControlLabel
                                  value="PB3"
                                  control={<Radio />}
                                  label={
                                    this.state.checkPB3 ? (
                                      <div>
                                        <del>프로그램 북 표3 – (1,100,000원)</del>
                                        <b style={{ color: 'red' }}>&nbsp;마감</b>
                                      </div>
                                    ) : (
                                      <div>프로그램 북 표3 – (1,100,000원)</div>
                                    )
                                  }
                                  disabled={this.state.checkPB3 === true}
                                />
                                <FormControlLabel
                                  value="PB4"
                                  control={<Radio />}
                                  label={
                                    this.state.checkPB4 ? (
                                      <div>
                                        <del>프로그램 북 표4 – (2,200,000원)</del>
                                        <b style={{ color: 'red' }}>&nbsp;마감</b>
                                      </div>
                                    ) : (
                                      <div>프로그램 북 표4 – (2,200,000원)</div>
                                    )
                                  }
                                  disabled={this.state.checkPB4 === true}
                                />

                                {/* {this.state.pgmBookAvailable &&
  this.state.pgmBookAvailable.map((item, idx) => {
    return (
      <FormControlLabel
        value={item.title}
        control={<Radio />}
        disabled={this.state.isAdd === 'N'}
        label={
          <div>
            프로그램 북 표{item.title.replace('PB', '')} – ({addComma(item.value)}원)
          </div>
        }
        key={item.title}
      />
    );
  })} */}
                                {/* <FormControlLabel value="PB1" control={<Radio />} label={<div>프로그램 북 표1 – (2,200,000원)</div>} />
<FormControlLabel value="PB2" control={<Radio />} label={<div>프로그램 북 표2 – (1,650,000원)</div>} />
<FormControlLabel value="PB3" control={<Radio />} label={<div>프로그램 북 표3 – (1,100,000원)</div>} />
<FormControlLabel value="PB4" control={<Radio />} label={<div>프로그램 북 표4 – (2,200,000원)</div>} /> 
*/}
                                {/* <FormControlLabel value="PB5" control={<Radio />} label={<div>프로그램북 내지 – (770,000원)</div>} />
<FormControlLabel value="eBOOK" control={<Radio />} label={<div>초록집 내지– (770,000원)</div>} /> */}
                              </RadioGroup>
                            )}

                            <FormControlLabel
                              label={
                                <Typography style={{ fontSize: 14 }}>
                                  {this.state.applicationType === ''
                                    ? '프로그램 북 내지 - 후원 구분을 선택해 주십시오.'
                                    : '프로그램 북 내지 – (770,000원/광고 수)'}
                                </Typography>
                              }
                              onChange={(e) => this.calcTotalPrice('innerBook', e)}
                              // value={this.state.isCheckInnerBook || false}
                              control={
                                <Checkbox
                                  checked={this.state.isCheckInnerBook !== 0}
                                  disabled={mode === 'read' || this.state.applicationType === ''}
                                  color="secondary"
                                  size="small"
                                  // onChange={(e) => {
                                  //   this.setState({
                                  //     isCheckInnerBook: e.target.checked ? 770000 : 0,
                                  //   });
                                  // }}
                                />
                              }
                            />

                            <FormControlLabel
                              label={
                                <Typography style={{ fontSize: 14 }}>
                                  {this.state.applicationType === ''
                                    ? '초록집 내지 - 후원 구분을 선택해 주십시오.'
                                    : '초록집 내지 – (770,000원/광고 수)'}
                                </Typography>
                              }
                              onChange={(e) => this.calcTotalPrice('innerAbstract', e)}
                              // value={this.state.isCheckInnerAbstract || false}
                              control={
                                <Checkbox
                                  checked={this.state.isCheckInnerAbstract !== 0}
                                  disabled={mode === 'read' || this.state.applicationType === ''}
                                  color="secondary"
                                  size="small"
                                  // onChange={(e) => {
                                  //   this.setState({
                                  //     isCheckInnerAbstract: e.target.checked ? 770000 : 0,
                                  //   });
                                  // }}
                                />
                              }
                            />
                          </FormControl>

                          {/* 프로그램 표 내지 광고 갯수 별 */}
                          {this.state.isCheckInnerBook !== 0 && (
                            <div style={{ height: '50%', display: 'flex', alignItems: 'center' }}>
                              {'프로그램 북 광고 신청 수 :'}&nbsp;
                              <FormControl size="small">
                                <Select
                                  variant="outlined"
                                  value={this.state.addPgmBookCount}
                                  disabled={mode === 'read'}
                                  // onChange={(e) => {
                                  //   this.setState({ addPgmBookCount: e.target.value });
                                  // }}
                                  onChange={(e) => this.calcTotalPrice('addPgmBookCount', e)}
                                  classes={{
                                    select: classes.addCountSelect,
                                  }}
                                >
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          )}
                          {/* *초록집 내지 광고 갯수 별 */}
                          {this.state.isCheckInnerAbstract !== 0 && (
                            <div style={{ height: '50%', display: 'flex', alignItems: 'center' }}>
                              {'초록집 내지 광고 신청 수 :'}&nbsp;
                              <FormControl size="small">
                                <Select
                                  variant="outlined"
                                  value={this.state.abstractCount}
                                  // onChange={(e) => {
                                  //   this.setState({ addCount: e.target.value });
                                  // }}
                                  onChange={(e) => this.calcTotalPrice('abstractCount', e)}
                                  classes={{
                                    select: classes.addCountSelect,
                                  }}
                                >
                                  <MenuItem value={1}>1</MenuItem>
                                  <MenuItem value={2}>2</MenuItem>
                                  <MenuItem value={3}>3</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          )}

                          <Grid item xs={12}>
                            <Typography style={{ fontSize: 14, lineHeight: 2, color: '#ff0000' }}>
                              * 프로그램북: 학술대회 당일 참석자에게 배포되는 프로그램 안내 책자(인쇄물 제작)
                              <br />* 초록집: pdf 형태로 학술대회 참석자에게 사전 배포
                            </Typography>
                          </Grid>
                        </div>
                      )}
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th" rowSpan={4}>
                      <span>*&nbsp;</span>홍보 품목
                    </StyledTableCell>
                    <StyledTableCell>
                      {mode === 'read' ? (
                        this.state.itemType
                      ) : (
                        <Grid container direction={'column'}>
                          전시참가 업체는 초록집 및 학회 홈페이지에 게시하여 드립니다. (게시내용: 업체명, 주요 취급품목과 간략한 설명,
                          연락처)
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="itemType"
                              name="itemType"
                              onChange={(e) => this.handleChange('itemType', e)}
                              className={classes.radioGroup}
                              value={this.state.itemType}
                            >
                              <FormControlLabel inputRef={this.refItemType} value="제약" control={<Radio />} label={<div>제약</div>} />
                              <FormControlLabel value="의료기기" control={<Radio />} label={<div>의료기기</div>} />
                              <FormControlLabel value="기타" control={<Radio />} label={<div>기타</div>} />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      )}
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        startAdornment={<InputAdornment position="start">1)</InputAdornment>}
                        onChange={(e) => {
                          this.handleChange('item1', e);
                        }}
                        value={this.state.item1}
                        readOnly={readOnly}
                        inputRef={this.refItem1}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        startAdornment={<InputAdornment position="start">2)</InputAdornment>}
                        onChange={(e) => {
                          this.handleChange('item2', e);
                        }}
                        value={this.state.item2}
                        readOnly={readOnly}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        startAdornment={<InputAdornment position="start">3)</InputAdornment>}
                        onChange={(e) => {
                          this.handleChange('item3', e);
                        }}
                        value={this.state.item3}
                        readOnly={readOnly}
                      />
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>총 금액 (VAT포함)
                    </StyledTableCell>
                    <StyledTableCell>
                      {this.state.totalPrice !== 0 && this.state.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      <span style={{ fontWeight: 'bold' }}>{this.state.totalPrice !== 0 ? '원' : '0 원'}</span> (VAT 포함)
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>입금 계좌번호
                    </StyledTableCell>

                    <StyledTableCell>하나은행 / 224-910038-66804 / 대한성형외과학회</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>입금 예정일
                    </StyledTableCell>
                    <StyledTableCell>
                      * 신청 후 <b>7일 이내에 입금</b>을 부탁드립니다. <br />
                      * 자리 선점 후 사전 협의 없이 미입금 시 대기업체로 부스 자리가 제공될 수 있음을 참고 해주시기 바랍니다. <br />* 입금
                      일정에 대한 자세한 문의나 협의는 학회 담당자(이지은 과장 Tel. 02-3472-4253)에게 연락 주십시오.
                      <Grid container style={{ marginTop: 10 }}>
                        <OutlinedInput
                          className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                          onClick={() => this.setState({ openCalendarDeposit: true })}
                          startAdornment={<InputAdornment position="start">입금 예정일 : </InputAdornment>}
                          value={(this.state.depositDate && moment(this.state.depositDate).format('YYYY-MM-DD')) || ''}
                          readOnly={readOnly}
                          inputRef={this.refDepositDate}
                          // style={{ width: 'fit-content' }}
                        />
                        {this.state.openCalendarDeposit && mode !== 'read' ? (
                          <Calendar
                            style={{ position: 'absolute', marginLeft: '0px !important', marginTop: '0px !important' }}
                            onChange={(date) => this.onChangeCal(date, 'depositDate')} /*value={value}*/
                          />
                        ) : (
                          ''
                        )}
                      </Grid>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell component="th">
                      <span>*&nbsp;</span>세금계산서 발행 정보
                    </StyledTableCell>

                    <StyledTableCell>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        style={{ marginBottom: 8 }}
                        startAdornment={<InputAdornment position="start">수령인 : </InputAdornment>}
                        onChange={(e) => {
                          this.handleChange('recipient', e);
                        }}
                        value={this.state.recipient}
                        readOnly={readOnly}
                        inputRef={this.refRecipient}
                      />
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        style={{ marginBottom: 8 }}
                        startAdornment={<InputAdornment position="start">발행 요청 이메일 : </InputAdornment>}
                        onChange={(e) => {
                          this.handleChange('taxEmail', e);
                        }}
                        value={this.state.taxEmail}
                        inputRef={this.refTaxEmail}
                        readOnly={readOnly}
                      />
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        startAdornment={<InputAdornment position="start">발행 요청일 : </InputAdornment>}
                        onClick={() => this.setState({ openCalendar: !this.state.openCalendar })}
                        value={(this.state.taxDate && moment(this.state.taxDate).format('YYYY-MM-DD')) || ''}
                        readOnly={readOnly}
                        inputRef={this.refTaxDate}
                      />
                      {this.state.openCalendar && mode !== 'read' ? (
                        <Calendar
                          style={{ position: 'absolute' }}
                          onChange={(date) => this.onChangeCal(date, 'taxDate')} /*value={value}*/
                        />
                      ) : (
                        ''
                      )}
                      <div style={{ marginTop: 10 }}>&nbsp;&nbsp;세금계산서 발행 문의 및 요청사항 (이지은 과장 Tel. 02-3472-4253)</div>
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component="th">기타 요청 사항</StyledTableCell>

                    <StyledTableCell>
                      <OutlinedInput
                        className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                        readOnly={readOnly}
                        onChange={(e) => {
                          this.handleChange('etc', e);
                        }}
                        value={this.state.etc}
                        style={{ paddingLeft: 0 }}
                      />
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {(this.state.totalPrice > 0 || this.state.isAdd === 'Y') && (
                <Grid style={this.state.applicationType === 'Online' ? {} : { marginTop: '1em' }}>
                  <h3 style={{ fontSize: 15, fontWeight: 'bold' }}>
                    ※ 온라인 신청에 따른 {this.state.applicationType === 'Online' && '회사소개, 제품광고, 배너광고, 회사로고 및 '}초록집
                    광고는 <span style={{ color: 'red' }}>10월 28일(금)</span>까지 Application Status에서 파일 업로드 부탁드립니다.
                  </h3>
                  <Table>
                    <TableBody>
                      {this.state.applicationType === 'Online' && (
                        <>
                          <TableRow>
                            <StyledTableCell component="th">회사 소개 (온라인 부스에 해당)</StyledTableCell>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'pdf1-picker'}
                                    accept="application/pdf, image/gif"
                                    onChange={(e) => this.onChangeFile(e, 'doc1')}
                                  />
                                  {this.state.doc1 && this.state.doc1.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.doc1.path} target={'_blank'}>
                                        {this.state.doc1.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'doc1')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * GIF, PDF
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell component="th">제품 소개 (온라인 부스에 해당)</StyledTableCell>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'pdf2-picker'}
                                    accept="application/pdf, image/gif"
                                    onChange={(e) => this.onChangeFile(e, 'doc2')}
                                  />
                                  {this.state.doc2 && this.state.doc2.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.doc2.path} target={'_blank'}>
                                        {this.state.doc2.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'doc2')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * GIF, PDF (210*297mm 사방여유 3mm포함)
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell component="th">회사 로고 (온라인 부스에 해당)</StyledTableCell>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'logo-picker'}
                                    accept="application/pdf, image/ai"
                                    onChange={(e) => this.onChangeFile(e, 'logo')}
                                  />
                                  {this.state.logo && this.state.logo.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.logo.path} target={'_blank'}>
                                        {this.state.logo.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'logo')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * AI, PDF
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell component="th">
                              배너 광고 <br />
                              (온라인 부스, 온라인 광고 공통)
                            </StyledTableCell>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'banner-picker'}
                                    accept="image/*"
                                    onChange={(e) => this.onChangeFile(e, 'banner')}
                                  />
                                  {this.state.banner && this.state.banner.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.banner.path} target={'_blank'}>
                                        {this.state.banner.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'banner')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * JPG, GIF, PNG (190*65)
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>

                          <TableRow>
                            <StyledTableCell component="th">
                              회사 홈페이지 링크 주소 <br /> (온라인 부스, 온라인 광고 공통)
                            </StyledTableCell>

                            <StyledTableCell>
                              {this.state.mode === 'read' ? (
                                this.state.homePage
                              ) : (
                                <OutlinedInput
                                  required
                                  className={mode === 'read' ? classes.borderNone : classes.OutlinedInput}
                                  onChange={(e) => {
                                    this.handleChange('homePage', e);
                                  }}
                                  value={this.state.homePage || ''}
                                  readOnly={readOnly}
                                />
                              )}
                            </StyledTableCell>
                          </TableRow>
                        </>
                      )}
                      {/* {this.state.isAdd !== 'eBOOK' && this.state.isAdd !== 'N' && ( */}
                      {
                        // this.state.isCheckInnerBook !== 0
                        (this.state.isAdd !== 'N' || this.state.isCheckInnerBook !== 0) && (
                          <>
                            <TableRow>
                              <StyledTableCell component="th" rowSpan={3}>
                                프로그램 북 광고파일 업로드
                              </StyledTableCell>
                              <StyledTableCell>
                                <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                  <Grid item xs={6}>
                                    <input
                                      style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                      type="file"
                                      id={'programbook-picker'}
                                      accept="image/*"
                                      onChange={(e) => this.onChangeFile(e, 'programBookTable')}
                                    />
                                    {this.state.programBookTable && this.state.programBookTable.path && (
                                      <span style={{ lineHeight: '30px' }}>
                                        <a href={this.state.programBookTable.path} target={'_blank'}>
                                          {this.state.programBookTable.name}
                                        </a>
                                        {this.state.mode === 'modify' && (
                                          <IconButton
                                            aria-label="delete"
                                            className={classes.margin}
                                            onClick={(e) => this.fileDelete(e, 'programBookTable')}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </span>
                                    )}
                                  </Grid>
                                  {this.state.mode !== 'read' && (
                                    <Grid item xs={6}>
                                      * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                    </Grid>
                                  )}
                                </Grid>
                              </StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTableCell>
                                <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                  <Grid item xs={6}>
                                    <input
                                      style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                      type="file"
                                      id={'programbook-picker'}
                                      accept="image/*"
                                      onChange={(e) => this.onChangeFile(e, 'programBookTable02')}
                                    />
                                    {this.state.programBookTable02 && this.state.programBookTable02.path && (
                                      <span style={{ lineHeight: '30px' }}>
                                        <a href={this.state.programBookTable02.path} target={'_blank'}>
                                          {this.state.programBookTable02.name}
                                        </a>
                                        {this.state.mode === 'modify' && (
                                          <IconButton
                                            aria-label="delete"
                                            className={classes.margin}
                                            onClick={(e) => this.fileDelete(e, 'programBookTable02')}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </span>
                                    )}
                                  </Grid>
                                  {this.state.mode !== 'read' && (
                                    <Grid item xs={6}>
                                      * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                    </Grid>
                                  )}
                                </Grid>
                              </StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTableCell>
                                <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                  <Grid item xs={6}>
                                    <input
                                      style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                      type="file"
                                      id={'programbook-picker'}
                                      accept="image/*"
                                      onChange={(e) => this.onChangeFile(e, 'programBookTable03')}
                                    />
                                    {this.state.programBookTable03 && this.state.programBookTable03.path && (
                                      <span style={{ lineHeight: '30px' }}>
                                        <a href={this.state.programBookTable03.path} target={'_blank'}>
                                          {this.state.programBookTable03.name}
                                        </a>
                                        {this.state.mode === 'modify' && (
                                          <IconButton
                                            aria-label="delete"
                                            className={classes.margin}
                                            onClick={(e) => this.fileDelete(e, 'programBookTable03')}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </span>
                                    )}
                                  </Grid>
                                  {this.state.mode !== 'read' && (
                                    <Grid item xs={6}>
                                      * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                    </Grid>
                                  )}
                                </Grid>
                              </StyledTableCell>
                            </TableRow>
                          </>
                        )
                      }

                      {/* {this.state.isAdd === 'eBOOK' && ( */}
                      {this.state.isCheckInnerAbstract !== 0 && (
                        <>
                          <TableRow>
                            <StyledTableCell component="th" rowSpan={3}>
                              초록집 광고
                            </StyledTableCell>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'banner-picker'}
                                    accept="image/*"
                                    onChange={(e) => this.onChangeFile(e, 'ad')}
                                  />
                                  {this.state.ad && this.state.ad.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.ad.path} target={'_blank'}>
                                        {this.state.ad.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'ad')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'banner-picker'}
                                    accept="image/*"
                                    onChange={(e) => this.onChangeFile(e, 'ad02')}
                                  />
                                  {this.state.ad02 && this.state.ad02.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.ad02.path} target={'_blank'}>
                                        {this.state.ad02.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'ad02')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                          <TableRow>
                            <StyledTableCell>
                              <Grid container spacing={1} alignItems="center" justifyContent={'flex-start'}>
                                <Grid item xs={6}>
                                  <input
                                    style={this.state.mode === 'read' ? { display: 'none' } : { display: 'block' }}
                                    type="file"
                                    id={'banner-picker'}
                                    accept="image/*"
                                    onChange={(e) => this.onChangeFile(e, 'ad03')}
                                  />
                                  {this.state.ad03 && this.state.ad03.path && (
                                    <span style={{ lineHeight: '30px' }}>
                                      <a href={this.state.ad03.path} target={'_blank'}>
                                        {this.state.ad03.name}
                                      </a>
                                      {this.state.mode === 'modify' && (
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={(e) => this.fileDelete(e, 'ad')}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </span>
                                  )}
                                </Grid>
                                {this.state.mode !== 'read' && (
                                  <Grid item xs={6}>
                                    * JPG, GIF, PNG (210*297mm 사방여유 3mm포함)
                                  </Grid>
                                )}
                              </Grid>
                            </StyledTableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </Grid>
              )}
              <Grid style={{ padding: 20 }}>
                <Typography className={classes.title} gutterBottom>
                  ※ 환불 규정 안내 및 동의
                </Typography>
                <div style={{ marginTop: 10, fontSize: '1.1em', lineHeight: '28px', border: '1px solid #ddd', padding: 20 }}>
                  - 등록 및 입금 순으로 자리가 배정되기 때문에 부스 신청을 취소할 경우 환불 규정에 따라 환불이 되오니, 등록 시 신중을 기해
                  주시기 바랍니다.
                  <br /> 1) 10월 21일(금) 이전 : 80% 환불
                  <br /> 2) 10월 22일(토)~28일(금) : 50% 환불
                  <br /> 3) 11월 4일(금) 이후 : 환불 불가
                  <br /> - 등록 취소 후 환불까지는 최대 30일이 소요될 수 있습니다.
                  <br /> - 등록 취소 절차는 학회 사무국 담당자(02-3472-4255)에게 연락 주시고 취소 여부를 반드시 확인하시기 바랍니다.
                  <br /> - 사전에 협의되지 않은 일방적인 불참의 경우 손해 배상을 청구할 수 있습니다.
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={mode === 'read'}
                        checked={this.state.isAgree || false}
                        onChange={(e) => {
                          this.setState({ isAgree: e.target.checked });
                        }}
                        color="secondary"
                        inputRef={this.refAgree}
                      />
                    }
                    label="위의 환불 규정에 동의합니다."
                  />
                </div>
              </Grid>

              {this.props.isAdmin && (
                <Grid
                  item
                  xs={12}
                  style={
                    this.props.isAdmin
                      ? navigator.userAgent.indexOf('Trident') !== -1
                        ? { padding: 20, minWidth: '960px' }
                        : { padding: 20 }
                      : { padding: 0 }
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline',
                      marginTop: 40,
                      marginBottom: 20,
                      borderBottom: `2px solid ${this.props.theme.palette.primary.main}`,
                    }}
                  >
                    <Typography className={classes.title} gutterBottom style={{ width: 'auto' }}>
                      Admin Memo
                    </Typography>
                  </div>
                  <TextareaAutosize
                    style={{ width: '100%', padding: 20 }}
                    minRows={10}
                    value={this.state.memo}
                    onChange={(e) => this.setState({ memo: e.target.value })}
                  />
                </Grid>
              )}
              {mode !== 'read' ? (
                <Grid
                  container
                  justifyContent="center"
                  alignitems="center"
                  style={this.props.isPop ? { marginBottom: '5vh', marginTop: '6vh' } : { marginBottom: '20vh', marginTop: '6vh' }}
                >
                  <ConfirmButton onClick={this.handleSignUp} color="primary">
                    {mode === 'modify' ? '수정' : '등록'}
                  </ConfirmButton>
                  <div style={{ width: '1em' }} />
                  <ConfirmButton
                    color="secondary"
                    onClick={() => {
                      if (this.props.isPop) {
                        this.props.handleClose();
                      } else {
                        mode === 'modify' ? this.setState({ mode: 'read' }) : this.props.history.push('/sponsor/signin');
                      }
                    }}
                  >
                    취소
                  </ConfirmButton>
                </Grid>
              ) : this.props.isPop ? (
                <Grid container justifyContent="center" alignitems="center" style={{ marginBottom: '5vh', marginTop: '6vh' }}>
                  <ConfirmButton color="secondary" onClick={this.props.handleClose}>
                    CLOSE
                  </ConfirmButton>
                </Grid>
              ) : (
                <Grid container justifyContent="center" alignitems="center" style={{ marginBottom: '20vh', marginTop: '6vh' }}>
                  <ConfirmButton color="secondary" onClick={this.changeToModifyMode}>
                    수정하기
                  </ConfirmButton>
                </Grid>
              )}
            </Grid>
          </Grid>
          {this.state.popUpOpen && (
            <div id="popupDom" className={classes.popupDiv}>
              <Paper elevation={3} className={classes.popupPaper}>
                <Grid container justifyContent="flex-end">
                  <IconButton aria-label="close" onClick={() => this.setPopupClose()}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <DaumPostcode onComplete={handleComplete} style={{ height: '450px' }} />
              </Paper>
            </div>
          )}
        </Container>
        {!this.props.isPop && <Footer />}
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(ExhibiApplication));
